import { render } from "./cristalMarker.vue?vue&type=template&id=060cc4ac"
import script from "./cristalMarker.vue?vue&type=script&lang=js"
export * from "./cristalMarker.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__